import { AccountStatement } from "./AccountStatement";

export class AccountStatementYear {
    Year: number;
    AccountStatements: AccountStatement[];
    constructor(year: number, accountStatements: AccountStatement[]) {
        this.Year = year;
        this.AccountStatements = accountStatements;
    }
}